import { useContext } from "react";
import { TabContext } from "./tabContext";

export const useTabContext = () => useContext(TabContext);